// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3B-KM","label":"Section_label__23wgU","contentWrap":"Section_contentWrap__3hG8Q","footer":"Section_footer__3FtwB","footerInner":"Section_footerInner__XcSIw"};